import _pt from '../../../node_modules/prop-types/index.js';

var confirmField = function confirmField() {
  return {
    propTypes: {
      confirmField: _pt.string,
      confirmFieldError: _pt.string
    },
    getNotifiedFields: function getNotifiedFields(props) {
      // we want to be notified if this field changes
      return props.confirmField ? [props.confirmField] : [];
    },
    shouldValidate: function shouldValidate(props) {
      return !!props.confirmField;
    },
    getErrors: function getErrors(field, value, props, context) {
      if (context.value && props.confirmField) {
        var otherField = context.value[props.confirmField];

        if (value && otherField && value !== otherField) {
          return [props.confirmFieldError || "".concat(field, " does not match")];
        }
      }

      return [];
    }
  };
};

export { confirmField };
